import { Box, rem } from '@mantine/core';
import type { EmotionSx } from '@mantine/emotion';
import { THEME_COLORS } from '@vrplatform/ui-common';
import type { ReactNode } from 'react';

export const VRPilotHighlight = ({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: EmotionSx;
}) => {
  if (children == null) return null;

  return (
    <Box
      component="span"
      data-vrpilot-highlight="active"
      sx={(theme, utils) => ({
        display: 'inline-flex',
        maxWidth: '100%',
        position: 'relative',
        '&::after': {
          border: `${rem(2)} solid ${THEME_COLORS.violet[6]}`,
          borderRadius: rem(9),
          content: '""',
          inset: rem(-5),
          pointerEvents: 'none',
          position: 'absolute',
          zIndex: 1,
        },
        ...(typeof sx === 'function' ? sx(theme, utils) : sx),
      })}
    >
      {children}
    </Box>
  );
};
